export const TextareaField = ({ field, register, errors, theme }) => (
  <textarea
    id={field.id}
    {...register(field.id, field.validation)}
    placeholder={field.placeholder}
    rows={field.rows || 4}
    className={`${theme.input} ${errors[field.id] ? theme.inputError : ''} resize-vertical`}
    disabled={field.disabled}
  />
);